// "use client";

// import * as React from "react";
// import {
//   Grid,
//   Button,
//   Box,
//   Typography,
//   FormControl,
//   TextField,
// } from "@mui/material";
// import { Link } from "react-router-dom";

// const SignInForm = () => {
//   return (
// <>
//   <Box
//     className="auth-main-wrapper sign-in-area"
// sx={{
//   py: { xs: "60px", md: "80px", lg: "100px", xl: "135px" },
// }}
//   >
// <Box
//   sx={{
// maxWidth: { sm: "500px", md: "1255px" },
// mx: "auto !important",
// px: "12px",
//   }}
// >
//   <Grid
//     container
//     alignItems="center"
//     columnSpacing={{ xs: 1, sm: 2, md: 4, lg: 3 }}
//   >
//             <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 7 }}>
//               <Box
//                 sx={{
//                   display: { xs: "none", md: "block" },
//                 }}
//               >
//                 <img
//                   src="/images/bharatonline.png"
//                   alt="sign-in-image"
//                   width={646}
//                   height={804}
//                   style={{
//                     borderRadius: "24px",
//                   }}
//                 />
//               </Box>
//             </Grid>

//             <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 5 }}>
//               <Box
//                 className="form-content"
//                 sx={{
//                   paddingLeft: { xs: "0", lg: "10px" },
//                 }}
//               >
//                 <Box
//                   className="logo"
//                   sx={{
//                     mb: "23px",
//                   }}
//                 >
//                   {/* <img
//                     src="/images/logo-big.svg"
//                     alt="logo"
//                     width={142}
//                     height={38}
//                   /> */}
//                   {/* <img
//                     src="/images/white-logo.svg"
//                     className="d-none"
//                     alt="logo"
//                     width={142}
//                     height={38}
//                   /> */}
//                    <Typography
//                     variant="h1"
//                     className="text-black"
//                     sx={{
//                       fontSize: { xs: "26px", sm: "29px", lg: "32px" },
//                       mb: "7px",
//                       fontWeight: "600",
//                     }}
//                   >
//                      Social
//                   </Typography>
//                 </Box>

//                 <Box
//                   className="title"
//                   sx={{
//                     mb: "23px",
//                   }}
//                 >
//                   <Typography
//                     variant="h1"
//                     className="text-black"
//                     sx={{
//                       fontSize: { xs: "22px", sm: "25px", lg: "28px" },
//                       mb: "7px",
//                       fontWeight: "600",
//                     }}
//                   >
//                     {/* Welcome back to Social! */}
//                   </Typography>

//                   <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
//                     Sign In with social account or enter your details
//                   </Typography>
//                 </Box>

//                 <Box
//                   className="with-socials"
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-around",
//                     gap: "5px",
//                     mb: "20px",
//                   }}
//                 >
//                   <Button
//                     variant="outlined"
//                     className="border bg-white"
//                     sx={{
//                       width: "100%",
//                       borderRadius: "8px",
//                       padding: "10.5px 20px",
//                     }}
//                   >
//                     <img
//                       src="/images/icons/google.svg"
//                       alt="google"
//                       width={25}
//                       height={25}
//                     />
//                   </Button>

//                   <Button
//                     variant="outlined"
//                     className="border bg-white"
//                     sx={{
//                       width: "100%",
//                       borderRadius: "8px",
//                       padding: "10.5px 20px",
//                     }}
//                   >
//                     <img
//                       src="/images/icons/facebook2.svg"
//                       alt="facebook"
//                       width={25}
//                       height={25}
//                     />
//                   </Button>

//                   <Button
//                     variant="outlined"
//                     className="border bg-white"
//                     sx={{
//                       width: "100%",
//                       borderRadius: "8px",
//                       padding: "10.5px 20px",
//                     }}
//                   >
//                     <img
//                       src="/images/icons/apple.svg"
//                       alt="apple"
//                       width={25}
//                       height={25}
//                     />
//                   </Button>
//                 </Box>

//                 <Box component="form">
//                   <Box mb="15px">
//                     <FormControl fullWidth>
//                       <Typography
//                         component="label"
//                         sx={{
//                           fontWeight: "500",
//                           fontSize: "14px",
//                           mb: "10px",
//                           display: "block",
//                         }}
//                         className="text-black"
//                       >
//                         Email Address
//                       </Typography>

//                       <TextField
//                         label="example&#64;Social.com"
//                         variant="filled"
//                         id="email"
//                         name="email"
//                         sx={{
//                           "& .MuiInputBase-root": {
//                             border: "1px solid #D5D9E2",
//                             backgroundColor: "#fff",
//                             borderRadius: "7px",
//                           },
//                           "& .MuiInputBase-root::before": {
//                             border: "none",
//                           },
//                           "& .MuiInputBase-root:hover::before": {
//                             border: "none",
//                           },
//                           "& .MuiInputBase-root:hover:hover:not(.Mui-disabled, .Mui-error)::before":
//                             {
//                               border: "none",
//                             },
//                         }}
//                       />
//                     </FormControl>
//                   </Box>

//                   <Box mb="15px">
//                     <FormControl fullWidth>
//                       <Typography
//                         component="label"
//                         sx={{
//                           fontWeight: "500",
//                           fontSize: "14px",
//                           mb: "10px",
//                           display: "block",
//                         }}
//                         className="text-black"
//                       >
//                         Password
//                       </Typography>

//                       <TextField
//                         label="Type Password"
//                         variant="filled"
//                         type="password"
//                         id="password"
//                         name="password"
//                         sx={{
//                           "& .MuiInputBase-root": {
//                             border: "1px solid #D5D9E2",
//                             backgroundColor: "#fff",
//                             borderRadius: "7px",
//                           },
//                           "& .MuiInputBase-root::before": {
//                             border: "none",
//                           },
//                           "& .MuiInputBase-root:hover::before": {
//                             border: "none",
//                           },
//                           "& .MuiInputBase-root:hover:hover:not(.Mui-disabled, .Mui-error)::before":
//                             {
//                               border: "none",
//                             },
//                         }}
//                       />
//                     </FormControl>
//                   </Box>

//                   <Box mb="20px">
//                     <Link
//                       to="/authentication/forgot-password/"
//                       className="text-primary"
//                       style={{
//                         fontWeight: "500",
//                       }}
//                     >
//                       Forgot Password?
//                     </Link>
//                   </Box>

//                   <Box mb="20px">
//                     <Button
//                       type="submit"
//                       variant="contained"
//                       sx={{
//                         textTransform: "capitalize",
//                         borderRadius: "6px",
//                         fontWeight: "500",
//                         fontSize: { xs: "13px", sm: "16px" },
//                         padding: { xs: "10px 20px", sm: "10px 24px" },
//                         color: "#fff !important",
//                         boxShadow: "none",
//                         width: "100%",
//                       }}
//                     >
//                       <i className="material-symbols-outlined mr-5">login</i>
//                       Sign In
//                     </Button>
//                   </Box>

//                   <Typography>
//                     Don’t have an account.{" "}
//                     <Link
//                       to="/authentication/sign-up/"
//                       className="text-primary"
//                       style={{
//                         fontWeight: "500",
//                       }}
//                     >
//                       Sign Up
//                     </Link>
//                   </Typography>
//                 </Box>
//               </Box>
//             </Grid>
//           </Grid>
//         </Box>
//       </Box>
//     </>
//   );
// };

// export default SignInForm;

import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { Form, Input, Button, Row, Col, Typography, message } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
// import loginImage from '../../../../public/images/bharatonline.png'
import { LOGIN_SUCCESS, loginSuccess } from "../../../redux/actions/action";
import { loginapi } from "../../../redux/api/api";
import { Box } from "@mui/material";
const { Text } = Typography;

const SignInForm = () => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const permissions = useSelector((state) => state.auth.permissions);
  // console.log(permissions)

  const onsubmit = async (data) => {
    console.log(data);
    setIsLoading(true);
    try {
      const res = await loginapi(data);
      console.log("response", res);
      if (res.status === 200) {
        const userObject = {
          name: res.data.info.admin.name,
          id: res.data.info.admin._id,
          email: res.data.info.admin.email,
          img: res.data.info.admin.image
            ? res.data.baseUrl + res.data.info.admin.image
            : null,
        };
        //console.log(userObject)
        Cookies.set("admin", JSON.stringify(userObject));
        const { admin, token, refreshToken } = res.data.info;

        dispatch(
          loginSuccess({
            admin,
            token,
            refreshToken,
          }),
        );

        Cookies.set("token", res.data.info.token);

        Cookies.set("refreshToken", res.data.info.refreshToken);
        message.success("Login successful!");
        navigate("/my-profile/");
      }
    } catch (err) {
      if (err.response?.status === 403) {
        message.warning("Your account is awaiting administrative approval.");
      } else {
        //console.log(err)
        setError(
          err.response?.data?.message || "An error occurred while logging in.",
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Box
        className="auth-main-wrapper sign-in-area"
        sx={{
          height: "100vh", // full screen, no scroll
          display: "flex", // flexbox center
          alignItems: "center",
          justifyContent: "center",
          // backgroundColor: "#f9fafb",         // optional background
          // px: 2,
          maxWidth: { sm: "500px", md: "1255px" },
          mx: "auto !important",
          px: "12px",
          py: { xs: "60px", md: "80px", lg: "100px", xl: "135px" },
        }}
      >
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            // backgroundColor: '#EAF0F5',
            padding: "20px",
          }}
        >
          <Row
            justify="center"
            style={{
              width: "100%",
              maxWidth: "900px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              borderRadius: "12px",
              overflow: "hidden",
            }}
          >
            {/* Left Column: Image */}
            <Col xs={0} sm={0} md={12}>
              <img
                src="/images/bharatonline.png"
                alt="Register Illustration"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Col>
            {/* Right Column: Login Form */}
            <Col
              xs={24}
              sm={24}
              md={12}
              style={{ backgroundColor: "#F9FCFF", padding: "40px" }}
            >
              <h1 style={{ fontWeight: "700", marginBottom: "10px" }}>Login</h1>
              <p
                style={{
                  fontWeight: "500",
                  color: "#666",
                  marginBottom: "20px",
                }}
              >
                Sign in to your account
              </p>
              {error && <Text type="danger">{error}</Text>}

              <Form layout="vertical" onFinish={handleSubmit(onsubmit)}>
                {/* Email */}
                <Form.Item
                  label="Email"
                  validateStatus={errors.email ? "error" : ""}
                  help={errors.email?.message}
                >
                  <Controller
                    name="email"
                    control={control}
                    defaultValue=""
                    rules={{
                      required: "Email is required",
                      pattern: {
                        value:
                          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                        message: "Invalid email format",
                      },
                    }}
                    render={({ field }) => (
                      <Input
                        {...field}
                        placeholder="Email"
                        prefix={<UserOutlined />}
                      />
                    )}
                  />
                </Form.Item>

                {/* Password */}
                <Form.Item
                  label="Password"
                  validateStatus={errors.password ? "error" : ""}
                  help={errors.password?.message}
                >
                  <Controller
                    name="password"
                    control={control}
                    defaultValue=""
                    rules={{ required: "Password is required" }}
                    render={({ field }) => (
                      <Input.Password
                        {...field}
                        placeholder="Password"
                        prefix={<LockOutlined />}
                      />
                    )}
                  />
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    block
                    loading={isLoading}
                  >
                    {isLoading ? "Loading..." : "Login"}
                  </Button>
                </Form.Item>
              </Form>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "20px",
                  gap: "8px",
                }}
              >
                <Text>Not registered?</Text>
                <Link to="/authentication/sign-up/">
                  <Button type="link">Register Now!</Button>
                </Link>
              </div>
            </Col>
          </Row>
        </div>
      </Box>
    </>
  );
};

export default SignInForm;
